let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dk7dI")).then(() => parcelRequire('1ilUf'));